import { startCase } from 'lodash-es';

export const notificationList = [
    {
        title: 'Business Reactivated',
        val: 'reactivated'
    },
    {
        title: 'Business Shared',
        val: 'shared'
    },
    {
        title: 'Connected to Bank',
        val: 'acceptedBankStatementsTerms'
    },
    {
        title: 'CX Interaction',
        val: 'cxInteraction'
    },
    {
        title: 'Deal Started',
        val: 'dealCreated'
    },
    {
        title: 'Deleted',
        val: 'deleted'
    },
    {
        title: 'Documents Uploaded',
        val: 'document'
    },
    {
        title: 'Follow Up Reminder',
        val: 'reminder-fired'
    },
    {
        title: 'Incoming Chat',
        val: 'chat'
    },
    {
        title: 'Incoming Phone Call',
        val: 'call'
    },
    {
        title: 'Lead Created',
        val: 'signup'
    },
    {
        title: 'Lender Document',
        val: 'lenderDocument'
    },
    {
        title: 'Lender Updated Deal',
        val: 'lenderUpdatedDeal'
    },
    {
        title: 'New Assignment',
        val: 'assignment'
    },
    {
        title: 'New Email',
        val: 'message'
    },
    {
        title: 'New Sms',
        val: 'sms'
    },
    {
        title: 'Offer Declined by Borrower',
        val: 'offerBorrowerDeclined'
    },
    {
        title: 'Request Completed',
        val: 'requestCompleted'
    },
    {
        title: 'Request Rejected',
        val: 'requestRejected'
    },
    {
        title: 'Sharing Removed',
        val: 'unshared'
    },
    {
        title: 'Status Change',
        val: 'status'
    },
    {
        title: 'Soft Pull Credit Check',
        val: 'softPullCreditCheck'
    },
    {
        title: 'Undelivered Message',
        val: 'bouncedMessage'
    }
];

export const activityDisplayAttrsMap = {
    'acceptedBankStatementsTerms': {
        icon: 'account_balance',
        title: 'Connected to Bank',
    },
    'assignment': {
        icon: 'person',
        title: 'New Assignment',
    },
    'bouncedMessage': {
        icon: 'email',
        title: 'Undelivered Message',
    },
    'call': {
        icon: 'call_received',
        title: 'Incoming Phone Call',
    },
    'chat': {
        icon: 'chat',
        title: 'Incoming Chat',
    },
    'created': {
        icon: 'new_releases',
        title: 'Lead Created',
    },
    'dealCreated': {
        icon: 'attach_money',
        title: 'Deal Started',
    },
    'deleted': {
        icon: 'delete',
        title: (activity) => activity.deletedType
            ? startCase(activity.deletedType) + ' Deleted'
            : 'Deleted',
    },
    'document': {
        icon: 'note_add',
        title: 'Document Uploaded',
    },
    'lenderDocument': {
        icon: 'note_add',
        title: 'Lender Document',
    },
    'lenderUpdatedDeal': {
        icon: 'attach_money',
        title: 'Lender Updated Deal',
    },
    'message': {
        icon: 'email',
        title: 'New Email',
    },
    'note': {
        icon: 'notes',
        title: 'New Note',
    },
    'offerBorrowerDeclined': {
        icon: 'not_interested',
        title: 'Offer Declined by Borrower',
    },
    'reactivated': {
        icon: 'new_releases',
        title: 'Business Reactivated',
    },
    'reminder-fired': {
        icon: 'schedule',
        title: 'Follow Up Reminder',
        timestamp: 'expires'
    },
    'shared': {
        icon: 'folder_shared',
        title: 'Business Shared',
    },
    'sms': {
        icon: 'message',
        title: 'New SMS',
    },
    'softPullCreditCheck': {
        icon: 'notifications',
        title: 'Soft Pull Credit Check',
    },
    'status': {
        icon: 'keyboard_tab',
        title: 'Status Change',
    },
    'unshared': {
        icon: 'notifications',
        title: 'Sharing Removed',
    },
};
